import React from 'react'

import MainDetail from '../MainDetail/MainDetail'
import Nav from '../Nav/Nav'
import Position from '../Position/Position'
import PositionsList from './PositionsList/PositionsList'

import positionsSceneContainer from './positionsSceneContainer'

export class PositionsScene extends React.Component {
  componentDidMount() {
    const { onLoad } = this.props

    if (onLoad) {
      onLoad()
    }
  }

  render() {
    const { selectedPosition } = this.props

    return (
      <div>
        <Nav />
        <MainDetail
          mainComponent={PositionsList}
          detailComponent={Position}
          currentView={selectedPosition ? 'detail' : 'main'}
        />
      </div>
    )
  }
}

export default positionsSceneContainer(PositionsScene)



// WEBPACK FOOTER //
// ./src/components/PositionsScene/PositionsScene.js